/* eslint-disable no-use-before-define */
import { toSearchableString, sortNumber, sortString } from 'app/utils';
import { generateMonth } from 'app/components/pages/monitoring/Utils';

const TEMPLATE_NAME = 'MONITORING';

const filterByTerm = (item, term) => {
  toSearchableString(item).includes(toSearchableString(term));
};

const filterDataSearch = (data, term) => {
  const resultData = {};

  const result = data.medicines.filter(item => {
    const Name = item.name ? filterByTerm(item.name, term) : false;

    return filterByTerm(item.name, term) || Name;
  });

  if (sort) {
    result.sort(sort);
  }

  resultData.monthMedicines = generateMonth(data.resume) ? generateMonth(data.resume) : [];

  resultData.medicines = result.length > 0 ? result : data.medicines;
  resultData.resume = data.resume ? data.resume : [];

  return resultData;
};

const filterData = data => {
  const medicines = [];
  const result = [];

  if (data && data.medicineCalendar) {
    // eslint-disable-next-line no-unused-vars
    for (let key in data.medicineCalendar) {
      medicines.push(data.medicineCalendar[key]);
    }

    result.resume = data.resume;
  }

  result.medicines = medicines;
  result.medicines.sort((a, b) => a.name.localeCompare(b.name));

  return result;
};

const initialState = () => ({
  loading: false,
  loadedData: [],
  filters: {
    term: '',
    data: []
  }
});

const sort = function (a, b) {
  let result = sortNumber(a.status, b.status);
  if (result !== 0) {
    return result;
  }
  const aName = a.name || null;
  const bName = b.name || null;
  result = sortString(aName, bName);
  if (result !== 0) {
    return result;
  }
  return sortString(a.key, b.key);
};

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      return {
        ...state,
        loading: false,
        data: filterDataSearch(filterData(newData), null)
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
      const { searchTerm } = action.payload;
      return {
        ...state,
        loading: false,
        filters: {
          ...state.filters,
          data: filterData(state.loadedData, searchTerm)
        }
      };
    }

    default:
      return state;
  }
};

export default reducer;
